import { Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'
import { DocumentShareRequest } from '../../types/reponse'

const formatDepartmentTargets = (row: DocumentShareRequest) => {
    if (row.target_department_names?.length) {
        return row.target_department_names.join(', ')
    }

    return '-'
}

const formatEmployeeTargets = (row: DocumentShareRequest) => {
    if (row.target_employee_names?.length) {
        return row.target_employee_names.join(', ')
    }

    return '-'
}

export const shareRequestColumns = (
    t: TFunction,
    onSelectDocument?: (row: DocumentShareRequest) => void
): GridColDefVNW<DocumentShareRequest>[] => [
    {
        field: 'document_id',
        headerName: t('document_id'),
        width: 70,
        renderCell: ({ row }) => (
            <Typogaphy
                size="small"
                className={`font-medium text-primary ${
                    onSelectDocument ? 'hover:underline cursor-pointer' : ''
                }`.trim()}
                onClick={
                    onSelectDocument ? () => onSelectDocument(row) : undefined
                }
            >
                {row.document_id}
            </Typogaphy>
        ),
    },
    {
        field: 'document_name',
        headerName: t('document_name'),
        minWidth: 220,
        flex: 1,
        renderCell: ({ row }) => (
            <Typogaphy
                size="small"
                className={`font-medium text-neutral-800 ${
                    onSelectDocument ? 'hover:underline cursor-pointer' : ''
                }`.trim()}
                onClick={
                    onSelectDocument ? () => onSelectDocument(row) : undefined
                }
            >
                {row.document_name || '-'}
            </Typogaphy>
        ),
    },
    {
        field: 'requester_name',
        headerName: t('requester'),
        width: 180,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row.requester_name || t('not_available')}
            </Typogaphy>
        ),
    },
    {
        field: 'approver_names',
        headerName: t('approvers'),
        minWidth: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row.approver_names?.length
                    ? row.approver_names.join(', ')
                    : t('unassigned')}
            </Typogaphy>
        ),
    },
    {
        field: 'target_departments',
        headerName: t('departments_shared'),
        minWidth: 200,
        flex: 1,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{formatDepartmentTargets(row)}</Typogaphy>
        ),
    },
    {
        field: 'target_employee_ids',
        headerName: t('employees_shared'),
        minWidth: 200,
        flex: 1,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{formatEmployeeTargets(row)}</Typogaphy>
        ),
    },
    {
        field: 'status',
        headerName: t('status'),
        width: 140,
        renderCell: ({ row }) => (
            <Typogaphy size="small" className="font-medium text-neutral-700">
                {t(`share_request.status.${row.status.toLowerCase()}`)}
            </Typogaphy>
        ),
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        width: 160,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row.created_at
                    ? dayjs(row.created_at).format('DD/MM/YYYY HH:mm')
                    : '-'}
            </Typogaphy>
        ),
    },
]
